const language = {
	spanish: {
		header_title: "Servicios",
		servicios_bold_title:
			"Foresight GPS® está comprometido con la innovación, desarrollo e investigación continua en el campo de la Geolocalización y Telemática. Contamos con múltiples servicios",
		servicios_bold_text:
			"Desarrollo de software de alto rendimiento (web y Mobile) marca blanca especializado en Geolocalización y Telemática",
		servicios_paragraphs: [
			"Al ser una fábrica de software, tenemos un grupo de desarrolladores especializados en geocoding y en constante actualización en las últimas tendencias del sector. Pero no solo es el equipo de desarrollo dedicado, también contamos con todo un equipo agile compuesto por Product Owners, especialistas en QA, ingenieros especializados en IoT y un equipos completo de DevOps. Nuestra metodología de trabajo es Scrum, lo que garantiza un desarrollo eficiente en el menor tiempo posible.",
		],
		servicios_2_bold_text: "Adopción de tecnología IoT para optimizar procesos",
		servicios_2_paragraphs: [
			"Nuestro equipo de Ingeniería en tecnología IoT está preparado para dar una asesoría completa sobre nuevas tecnologías que desee implementar en su negocio. Al ser una compañía de software especializada en Geolocalización y Telemática tenemos toda la experiencia en la materia.",
		],
		caracteristicas_yellow_title: "CARACTERÍSTICAS",
		caracteristicas_bold_text: "Integración con servicios web (API)",
		caracteristicas_paragraphs: [
			"Muchos de nuestros clientes ya tienen sistemas de gestión propios y solo necesitan alimentar dichos sistemas con la data extraída de nuestra plataforma. Al tener un equipo de desarrollo propio y especializado, podemos crear diversos tipos de API o servicios webs para ser integrados con cualquier sistema de terceros.",
		],
		caracteristicas_2_bold_text:
			"Homologación de dispositivos de geolocalización disponibles en el mercado",
		caracteristicas_2_paragraphs: [
			"Nuestra plataforma admite una inmensa cantidad de dispositivos de diversos modelos y marcas. Sin embargo, el ecosistema de dispositivos GPS disponibles en el mercado es enorme, es por ello que si cuanto con algún dispositivo que no está en nuestro catálogo de dispositivos homologados, Foresight GPS puede hacer la integración de este dispositivos en tiempo récord.",
		],
	},
	english: {
		header_title: "Services",
		servicios_bold_title:
			"ForesightGPS is committed to continuous innovation, development, and research in the field of geolocation and telematics. We offer multiple services",
		servicios_bold_text:
			"Development of high-performance software (web and mobile) white label, specialized in geolocation and telematics.",
		servicios_paragraphs: [
			"Being a software factory, we have a group of developers specialized in geocoding and are constantly updating themselves on the latest trends of the business. But not only they are dedicated, we also have teams of Product Owners, QA specialists, IoT engineers, and a full DevOps team doing the same thing. Our work methodology is Scrum, which guarantees efficient development in the shortest time possible.",
		],
		servicios_2_yellow_title: "Services",
		servicios_2_bold_text: "Adoption of IoT technology to optimize processes",
		servicios_2_paragraphs: [
			"Our engineering team in IoT technology is prepared to give complete advice on new technologies you may want to implement in your business. Being a software company specialized in geolocation and telematics we have vast experience on the matter.",
		],
		caracteristicas_yellow_title: "FEATURES",
		caracteristicas_bold_text: "Integration with web services (API)",
		caracteristicas_paragraphs: [
			"Many of our clients already have their own management system, they only need the data from our platform and take it into their system. By having our own specialized development team, we can create various types of APIs or web services to integrate with any third-party system.",
		],
		caracteristicas_2_yellow_title: "FEATURES",
		caracteristicas_2_bold_text:
			"Homologation of geolocation devices available on the market",
		caracteristicas_2_paragraphs: [
			"Our platform supports many devices of all kinds. However, the variety of GPS devices in the market is huge, but if you find a device that is not in our catalog, ForesightGPS can integrate this device in record time.",
		],
	},
};

export default language;
